export enum SSLCertificateStatus {
  NOT_INITIATED = "NOT_INITIATED",
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  SCHEDULED = "SCHEDULED",
}
